import MobileNavigation from '@components/components/Navigation/components/MobileNavigation/MobileNavigation';
import { usePageData } from '@components/context';
import React from 'react';

const ReducedMobileNavigation = () => {
  const {
    mainMenu,
    title,
    rootLevel,
    layoutStructure: { logoLink, logoLinkDescription, logoType },
  } = usePageData();

  const items = [{ children: mainMenu, title }];

  return (
    <MobileNavigation
      isReduced
      items={items}
      logoLink={logoLink}
      logoLinkDescription={logoLinkDescription}
      logoType={logoType}
      rootLevel={rootLevel}
    />
  );
};

export default ReducedMobileNavigation;
